import * as React from 'react';
import { SVGProps } from 'react';
export const UploadIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14}
    height={12}
    viewBox="0 0 14 12"
    fill="none"
    {...props}
  >
    <path
      fill="#6E7384"
      d="M8 4a1 1 0 1 1 2 0 1 1 0 0 1-2 0Zm5.75-2.5v9a1.25 1.25 0 0 1-1.25 1.25h-11A1.25 1.25 0 0 1 .25 10.5v-9A1.25 1.25 0 0 1 1.5.25h11a1.25 1.25 0 0 1 1.25 1.25Zm-12 .25v4.982l2.116-2.116a1.25 1.25 0 0 1 1.768 0l2.573 2.572L9.28 6.114a1.25 1.25 0 0 1 1.767 0l1.202 1.204V1.75H1.75Zm0 8.5h7.396L4.75 5.854l-3 3v1.396Zm10.5 0v-.813l-2.086-2.085-.896.898 2 2h.982Z"
    />
  </svg>
);
